import React from 'react';

const PolicyCard = () => {
  return <div>PolicyCard</div>;
};

export default PolicyCard;
